import { useGeneratePath, useStaticUrls } from 'platform-components/common';
import { useCallback } from 'react';

type GetClassroomCourseUrlArg = {
    courseId: number;
};

export const useGetClassroomCourseUrl = () => {
    const { classroomCourse } = useStaticUrls();
    const generatePath = useGeneratePath();

    return useCallback(
        ({ courseId }: GetClassroomCourseUrlArg) => {
            return generatePath(classroomCourse, { courseId });
        },
        [classroomCourse, generatePath]
    );
};
